import { App, Plugin } from "vue";
import applyApi, { ApplyApi } from "./modules/apply";
import userApi, { UserApi } from "./modules/user";
import uploadApi, { UploadApi } from "./modules/upload";
import templateApi, { TemplateApi } from "./modules/template";
import vehicleApplyApi, { VehicleApplyApi } from "./modules/vehicleApply";
import qrcodeApi, { QrcodeApi } from "./modules/qrcode";
import loginApi, { LoginApi } from "./modules/login";
export type ApiPlugin = Plugin & ApplyApi & UserApi & UploadApi & TemplateApi & VehicleApplyApi & QrcodeApi & LoginApi;
const apiPlugin: ApiPlugin = {
  install(app: App) {
    app.config.globalProperties.$api = apiPlugin;
  },
  ...applyApi,
  ...userApi,
  ...uploadApi,
  ...templateApi,
  ...vehicleApplyApi,
  ...qrcodeApi,
  ...loginApi,
};
export default apiPlugin;
declare module "@vue/runtime-core" {
  interface ComponentCustomProperties {
    $api: ApiPlugin;
  }
}
export * from "./type";
